import { defineStyleConfig } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const nestedModalForSize = (size: string) => ({
  dialog: {
    ".chakra-portal .chakra-portal &": {
      maxWidth: `calc(var(${`--chakra-sizes-${size}`}) - 2 * var(--chakra-space-2))`,
      mt: "calc(var(--chakra-space-16) + var(--chakra-space-2))",
      borderRadius: "base",
    },
  },
});

const modalPadding = 6;

export const ModalTheme = defineStyleConfig({
  baseStyle: (props) => ({
    overlay: {
      bg: mode("blackAlpha.500", "blackAlpha.700")(props),
    },
    dialog: {
      bg: "appBackground",
      borderRadius: "md",
      pt: modalPadding,
      gap: modalPadding,
      borderColor: mode("transparent", "appBorder")(props),
      borderStyle: "solid",
      borderWidth: "1px",
    },
    header: {
      py: 0,
      px: modalPadding,
      h2: {
        fontSize: ["lg", "xl", "2xl"],
      },
    },
    body: {
      py: 0,
      px: modalPadding,
    },
    footer: {
      px: modalPadding,
      py: 5,
      borderTop: "1px solid",
      borderTopColor: "appBorder",
      borderBottomRightRadius: "md",
      borderBottomLeftRadius: "md",
    },
    closeButton: {
      borderRadius: "full",
      p: 4,
      top: 4,
      right: 4,
    },
  }),
  sizes: {
    sm: nestedModalForSize("sm"),
    md: nestedModalForSize("md"),
    lg: nestedModalForSize("lg"),
    xl: nestedModalForSize("xl"),
    "2xl": nestedModalForSize("2xl"),
    "3xl": nestedModalForSize("3xl"),
    "4xl": nestedModalForSize("4xl"),
    "5xl": nestedModalForSize("5xl"),
    "6xl": nestedModalForSize("6xl"),
  },
  variants: {
    video: {
      dialog: {
        pt: 0,
        mx: 5,
        borderRadius: "xl",
      },
      body: {
        p: 0,
        overflow: "hidden",
        borderRadius: "xl",
      },
      closeButton: {
        top: -4,
        right: -4,
        background: "appBackground",
        boxShadow: "lg",
        _hover: {
          background: "appBackground",
        },
        _active: {
          background: "appBackground",
        },
      },
    },
  },
});
